import React from "react";
import { Button, ButtonGroup, Col, Form, Row } from "react-bootstrap";

import { useTeamContext } from "../contexts/Team";

const AdminSettings = (): React.JSX.Element => {
    const { team, formMethods: methods } = useTeamContext();
    const isHidingResumeFromCoach = methods.watch(
        "settings.hideResumeFromCoach",
        team?.settings?.hideResumeFromCoach || false,
    );
    const isHidingResumeFromPlacement = methods.watch(
        "settings.hideResumeFromPlacement",
        team?.settings?.hideResumeFromPlacement || false,
    );
    const isShowingResumeToCoach = methods.watch(
        "settings.showResumeToCoach",
        team?.settings?.showResumeToCoach || false,
    );

    return (
        <div data-testid="teamAdminSettings">
            <Row>
                <Col>
                    <Form.Group
                        controlId="hideResumeFromCoach"
                        data-testid="hideResumeFromCoach"
                    >
                        <Form.Label>Hide Resume From Coach</Form.Label>
                        <Form.Control
                            type="hidden"
                            {...methods.register(
                                "settings.hideResumeFromCoach",
                                {
                                    value: isHidingResumeFromCoach
                                        ? true
                                        : methods.getValues(
                                              "settings.hideResumeFromCoach",
                                          ) ||
                                          team?.settings?.hideResumeFromCoach,
                                },
                            )}
                        />
                        <br />
                        <ButtonGroup>
                            <Button
                                variant={
                                    isHidingResumeFromCoach
                                        ? "primary"
                                        : "outline-primary"
                                }
                                onClick={() =>
                                    methods.setValue(
                                        "settings.hideResumeFromCoach",
                                        true,
                                    )
                                }
                            >
                                Yes
                            </Button>
                            <Button
                                variant={
                                    isHidingResumeFromCoach
                                        ? "outline-primary"
                                        : "primary"
                                }
                                onClick={() =>
                                    methods.setValue(
                                        "settings.hideResumeFromCoach",
                                        false,
                                    )
                                }
                            >
                                No
                            </Button>
                        </ButtonGroup>
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Form.Group
                        controlId="hideResumeFromPlacement"
                        data-testid="hideResumeFromPlacement"
                    >
                        <Form.Label>Hide Resume From Placement</Form.Label>
                        <Form.Control
                            type="hidden"
                            {...methods.register(
                                "settings.hideResumeFromPlacement",
                                {
                                    value: isHidingResumeFromPlacement
                                        ? true
                                        : methods.getValues(
                                              "settings.hideResumeFromPlacement",
                                          ) ||
                                          team?.settings
                                              ?.hideResumeFromPlacement,
                                },
                            )}
                        />
                        <br />
                        <ButtonGroup>
                            <Button
                                variant={
                                    isHidingResumeFromPlacement
                                        ? "primary"
                                        : "outline-primary"
                                }
                                onClick={() =>
                                    methods.setValue(
                                        "settings.hideResumeFromPlacement",
                                        true,
                                    )
                                }
                            >
                                Yes
                            </Button>
                            <Button
                                variant={
                                    isHidingResumeFromPlacement
                                        ? "outline-primary"
                                        : "primary"
                                }
                                onClick={() =>
                                    methods.setValue(
                                        "settings.hideResumeFromPlacement",
                                        false,
                                    )
                                }
                            >
                                No
                            </Button>
                        </ButtonGroup>
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Form.Group
                        controlId="showResumeToCoach"
                        data-testid="showResumeToCoach"
                    >
                        <Form.Label>
                            Force Show Resume section to Coach
                        </Form.Label>
                        <Form.Control
                            type="hidden"
                            {...methods.register("settings.showResumeToCoach", {
                                value: isShowingResumeToCoach
                                    ? true
                                    : methods.getValues(
                                          "settings.showResumeToCoach",
                                      ) || team?.settings?.showResumeToCoach,
                            })}
                        />
                        <br />
                        <ButtonGroup>
                            <Button
                                variant={
                                    isShowingResumeToCoach
                                        ? "primary"
                                        : "outline-primary"
                                }
                                onClick={() =>
                                    methods.setValue(
                                        "settings.showResumeToCoach",
                                        true,
                                    )
                                }
                            >
                                Yes
                            </Button>
                            <Button
                                variant={
                                    isShowingResumeToCoach
                                        ? "outline-primary"
                                        : "primary"
                                }
                                onClick={() =>
                                    methods.setValue(
                                        "settings.showResumeToCoach",
                                        false,
                                    )
                                }
                            >
                                No
                            </Button>
                        </ButtonGroup>
                    </Form.Group>
                </Col>
            </Row>
        </div>
    );
};

export default AdminSettings;
